export const bodyScrollLocker = {
  update(el, binding) {
    if (binding.value) {
      document.body.style.overflowY = 'hidden'
      return
    }
    document.body.style.overflowY = 'auto'
  }
}
